import { z } from 'zod';

// パスワード再設定フォームのバリデーションスキーマ
export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(1, 'パスワードは必須です')
      .min(8, 'パスワードは8文字以上で入力してください')
      .regex(
        /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/,
        'パスワードは半角英数字を組み合わせてください'
      ),
    confirmPassword: z.string().min(1, '確認パスワードは必須です'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'パスワードが一致しません',
    path: ['confirmPassword'],
  });
